function toggleAccordionButtonStyle(button, active) {
    if (!button) return;

    const classes = ['border-bottom-0', 'shadow-none', 'rounded-bottom-0'];
    classes.forEach(cls => button.classList.toggle(cls, active));
}

kombi.accordion = function() {
    const accordionsCollapse = document.querySelectorAll('.accordion-item.custom-plain .accordion-collapse');

    accordionsCollapse.forEach(accordion => {
        accordion.addEventListener('show.bs.collapse', () => {
            const button = accordion.closest('.accordion-item')?.querySelector('.accordion-button');
            toggleAccordionButtonStyle(button, true);

            /*TODO: ajustar quando tiver o aereo.
            accordionsCollapse.forEach(otherAccordion => {
                if (otherAccordion !== accordion) {
                    const otherInstance = bootstrap.Collapse.getInstance(otherAccordion);
                    if (otherInstance) {
                        otherInstance.hide();
                        const otherButton = otherAccordion.closest('.accordion-item')?.querySelector('.accordion-button');
                        toggleAccordionButtonStyle(otherButton, false);
                    }
                }
            });*/
        });

        accordion.addEventListener('hide.bs.collapse', () => {
            const button = accordion.closest('.accordion-item')?.querySelector('.accordion-button');
            toggleAccordionButtonStyle(button, false);
        });
    });
};

kombi.accordionScroll = function(type, roomLoopCounter) {
    const accordion = document.querySelector("#accordionResulOccupation")
    const accordionItem = accordion.querySelector("#accordionItem" + roomLoopCounter);
    if (type == "accordionButton") {
        accordion.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    } else {
        accordionItem.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    }
}